import '../configuracoes.css'

import { useState, useEffect } from 'react';

import { servGetPontosFacultativosMes, servPostPontoFacultativo } from '../../../servicos/servicosEmRotasPrivadas/pontoFacultativo';

import minusIcon from '../../../imagens/minus.png'
import plusIcon from '../../../imagens/plus-sign.png'

import toast from 'react-hot-toast';
import BarraBuscaCpf from '../../BarraBuscaCpf';
import TituloSessao from '../../TituloSessao';
import FlatpickrControlled from '../../FlatpickrControlled';
import { formatCPF } from '../../../util/utilitarios';
import { toastErrorPydantic } from '../../../util/toast_pydantic';
import DataMesControlled from '../../DataMesControlled';

function CadastraPontoFacultativo() {

    console.log('### Iniciando CadastraPontoFacultativo ###');

    const [pontoFacultativoPayload, setPontoFacultativoPayload] = useState(
        {
            data: null,
            descricao: null
        }
    )

    const postPontoFacultativo = async () => {
        try {
            await toast.promise(
                servPostPontoFacultativo(pontoFacultativoPayload),
                { loading: 'Associando CPF...' }
            )
            setPontoFacultativoPayload({ data: null, descricao: null }) // reseta aqui
            toast.success('Ponto facultativo cadastrado com sucesso!')
        } catch (error) {
            toastErrorPydantic(error);
        }
    }

    return (
        <div className='container-configuracoes div-com-borda'>
            <strong>
                <p className='m-0 fs-5'>Informe os dados para cadastro do ponto facultativo</p>
            </strong>
            <div className='d-flex flex-column flex-md-row gap-3'>
                <div className="col-12 col-md-7">
                    <label htmlFor="descricao" className="form-label">Descrição</label>
                    <input
                        type="text"
                        className="form-control"
                        id="descricao"
                        value={pontoFacultativoPayload.descricao ?? ''}
                        onChange={(e) => setPontoFacultativoPayload(prev => ({
                            ...prev,
                            descricao: e.target.value
                        }))}
                    />
                    <div className="form-text">
                        Dê uma descrição ao ponto facultativo, apenas para um melhor registro em caso de consultas futuras
                    </div>
                </div>
                <div className="col-12 col-md-4">
                    <label htmlFor="data" className="form-label">Data</label>
                    <FlatpickrControlled
                        id="data"
                        date={pontoFacultativoPayload.data}
                        onChange={(value) => setPontoFacultativoPayload(prev => ({
                            ...prev,
                            data: value
                        }))}
                    />
                </div>
            </div>
            <button className='text-nowrap btn btn-primary' type='button' onClick={postPontoFacultativo}>
                CADASTRAR
            </button>
        </div>
    )
}

export default CadastraPontoFacultativo
